import createFriendlyCaptchaWidget from './component.js'

function registerFriendlyCaptchaWidget() {
    window.Alpine.data('friendlyCaptchaWidget', createFriendlyCaptchaWidget)
}

if (window.Alpine) {
    registerFriendlyCaptchaWidget()
} else {
    document.addEventListener('alpine:init', registerFriendlyCaptchaWidget, { once: true })
}
